// extracted by mini-css-extract-plugin
module.exports = {"filter":"KtKUNRStn9d29E75s2Ek"};